import { useEffect } from 'react';
import { Socket } from 'socket.io-client';
import { useSocketContext } from '../context/SocketContext';

export interface UseSocketReturn {
    isConnected: boolean;
    emit: (event: string, data: any) => void;
    on: (event: string, callback: (...args: any[]) => void) => () => void;
    socket: Socket | null;
}

/**
 * Hook to access the global socket connection.
 * Optionally joins a game room if gameId is provided.
 */
export function useSocket(gameId?: string): UseSocketReturn {
    const { isConnected, emit, on, socket, joinGame } = useSocketContext();

    useEffect(() => {
        if (isConnected && gameId) {
            console.log(`[useSocket] Requested join for gameId: ${gameId}`);
            joinGame(gameId);
        }
    }, [isConnected, gameId, joinGame]);

    return {
        isConnected,
        emit,
        on,
        socket
    };
}
